<sd-slider
  [customConfig]="argumentsSliderConfig"
  [itemTemplate]="argumentsTemplate"
  [items]="data"
  [brand]="brand"
  [size]="sizesEnum.l"
  [isFullWidth]="true"
  (slideNext)="onSlideNext($event)"
  (slidePrev)="onSlidePrev($event)"
  [context]="context"
/>

<ng-template #argumentsTemplate let-item let-index="index">
  <sd-arguments
    [isLoading]="isLoading"
    [textConfig]="item?.textConfig"
    [brand]="brand ? brand : item?.brand"
    [activeBrand]="activeBrand"
    #arguments
    [hasGradient]="item?.hasGradient"
    [layoutTextConfig]="item?.layoutTextConfig"
    [data]="item?.contentData"
    [imageRatio]="item?.imageRatio"
    [titleLevel]="item?.titleLevel"
    [layout]="layout"
    [isSmall]="item?.isSmall"
    (videoPlayed)="onVideoPlayed(item)"
    (videoEnded)="onVideoEnded(item)"
    (clicked)="onClicked($event)"
    [themesConfig]="item?.themesConfig"
    [twicPicsAutoSize]="twicPicsAutoSize || index >= 1"
  />
</ng-template>
